<template>
	<div class="app-container">
		<el-tabs type="border-card" v-model="activeName" v-tab-change:activeName="setActiveName">
			<!-- 积分规则 -->
			<el-tab-pane label="积分规则" name="0">
				<CreditRuleList />
			</el-tab-pane>
	
			<!-- 积分规则映射 -->
			<el-tab-pane label="积分规则映射" name="1">
				<CreditRuleMapList />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import CreditRuleList from "@/views/systemManagement/CreditRule/CreditRuleList"
	import CreditRuleMapList from "@/views/systemManagement/CreditRule/CreditRuleMapList"
	
	export default {
		components: {
			CreditRuleList,
			CreditRuleMapList
		},
    data(){
      return{
        activeName:"0"
      }
    }
	}
</script>

<style>
</style>